<!-- {{is_mobile | json}} -->
<div class="cases_page tasks_page" *ngIf="!is_mobile">
    <div class="container">
      <div class="filter_out">  
        <div class="filter_values">
          <app-active-filters [section]="'Files'" [company_id]="company_id" [filter]="filter" [filterValue]="filter.value" (RemoveValue)="removeValue($event)" (RemoveValueFromMultiple)="removeValueFromMultiple($event)"></app-active-filters>
          <!-- <mat-chip-list class="chips_wrp without_ordered start_page_chips">
            
            <mat-chip (removed)="removeValue('q')" *ngIf="activatedRoute.snapshot.queryParamMap.get('q')">
              {{activatedRoute.snapshot.queryParamMap.get('q')}}
              <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
            </mat-chip>
              
            <ng-container *ngIf="!!filter.get('operation_reminder_id').value">
                <span class="chip_out_label">{{ "Checklist" | translate }}:</span>
                <mat-chip (removed)="removeValue('operation_reminder_id')" >
                    {{ getChecklist(filter.get('operation_reminder_id').value)?.text }}
                    <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                </mat-chip>
            </ng-container>
            <mat-chip (removed)="removeValue('task_custom_id')" *ngIf="filter?.get('task_custom_id')?.value">
              {{ "Card custom ID" | translate }}: {{ filter?.get('task_custom_id')?.value }}
              <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
            </mat-chip>
            <mat-chip (removed)="removeValue('file_id')" *ngIf="filter?.get('file_id')?.value">
              {{ "File ID" | translate }}: {{ filter?.get('file_id')?.value }}
              <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
            </mat-chip>
            <mat-chip (removed)="removeValue('content_type')" *ngIf="filter?.get('content_type')?.value">
              {{ "Content type" | translate }}: {{ filter?.get('content_type')?.value }}
              <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
            </mat-chip>
            <mat-chip (removed)="removeValue('is_ready_if_approved')" *ngIf="filter.get('is_ready_if_approved').value == '0' || filter.get('is_ready_if_approved').value">
                <ng-container *ngIf="filter.get('is_ready_if_approved').value == '0'; else elseTemplateReadyIf">
                    {{ 'Not Ready Version if Approved' | translate }}
                </ng-container>
                <ng-template #elseTemplateReadyIf>
                    {{ 'Ready Version if Approved' | translate }}
                </ng-template>
                <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
            </mat-chip>

            <mat-chip (removed)="removeValue('priority')" *ngIf="filter.get('priority').value">
                {{getPriority(filter.get('priority').value)?.name | translate}}
                <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
            </mat-chip>

            <mat-chip (removed)="removeValue('part_of_count')" *ngIf="filter.get('part_of_count').value">
              <ng-container [ngSwitch]="filter.get('part_of_count').value">
                <ng-container *ngSwitchCase="'0'">
                  {{ "Isn`t part of file" | translate }}
                </ng-container>
                <ng-container *ngSwitchCase="'isset'">
                  {{ "Is part of file" | translate }}
                </ng-container>
              </ng-container>
              <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
            </mat-chip>

            <mat-chip (removed)="removeValue('consist_of_count')" *ngIf="filter.get('consist_of_count').value">
              <ng-container [ngSwitch]="filter.get('consist_of_count').value">
                <ng-container *ngSwitchCase="'0'">
                  {{ "Hasn't parts" | translate }}
                </ng-container>
                <ng-container *ngSwitchCase="'isset'">
                  {{ "Has parts" | translate }}
                </ng-container>
              </ng-container>
              <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
            </mat-chip>

            <mat-chip (removed)="removeValue('related_count')" *ngIf="filter.get('related_count').value">
              <ng-container [ngSwitch]="filter.get('related_count').value">
                <ng-container *ngSwitchCase="'0'">
                  {{ "Isn`t related" | translate }}
                </ng-container>
                <ng-container *ngSwitchCase="'isset'">
                  {{ "Is related" | translate }}
                </ng-container>
              </ng-container>
              <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
            </mat-chip>

            <mat-chip (removed)="removeValue('meta_device')" *ngIf="filter.get('meta_device').value">
                {{ filter.get('meta_device').value }}
                <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
            </mat-chip>
    
            <mat-chip (removed)="removeValue('task_status_id')" *ngIf="filter.get('task_status_id').value">
              {{ getTaskStatusById(filter.get('task_status_id').value)?.name }}
              <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
            </mat-chip>

            <mat-chip (removed)="removeValue('content_status_id')" *ngIf="filter.get('content_status_id').value">
              {{"Posts card status" | translate}}: {{ getProfileStatus(filter.get('content_status_id').value)?.name+'_profile' | translate }}
              <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
            </mat-chip>

            <mat-chip (removed)="removeValue('task_channel_file_content_status_id')" *ngIf="filter.get('task_channel_file_content_status_id').value">
              {{"Posts file status" | translate}}: {{ (filter.get('task_channel_file_content_status_id').value == 'no' ? "Not used in posts" : getProfileStatus(filter.get('task_channel_file_content_status_id').value)?.name+'_profile') | translate }}
              <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
            </mat-chip>

            <ng-container *ngIf="filter.get('group_id').value.length">
              <span class="chip_out_label">{{ "Group" | translate }}</span>
              <mat-chip *ngFor="let id of filter.get('group_id').value" (removed)="removeValueFromMultiple('group_id', id)">
                <ng-container *ngIf="id === 0; else elseTemplateNoGroup">
                  {{ "Goup not set" | translate }}
                </ng-container>
                <ng-template #elseTemplateNoGroup>
                  {{getGroup(id) ? getGroup(id)?.name : getPartnerGroup(id)?.name}}
                </ng-template>
                <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
              </mat-chip>
            </ng-container>

            <mat-chip (removed)="removeValue('content_type_id')" *ngIf="filter.get('content_type_id').value || filter.get('content_type_id').value.toString() == '0'">
                <ng-container *ngIf="filter.get('content_type_id').value.toString() == '0'; else elseTemplateZeroContent">
                    {{ "Content Type" | translate }}: {{ "Not set" | translate }}
                </ng-container>
                <ng-template #elseTemplateZeroContent>
                    {{ "Content Type" | translate }}: {{ getContentById(filter.get('content_type_id').value)?.name }}
                </ng-template>
             
                <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
            </mat-chip>

            <mat-chip class="user_chip" (removed)="removeValue('channel_platform_id')" *ngIf="filter.get('channel_platform_id').value || filter.get('channel_platform_id').value.toString() == '0'">
              <div class="platform_wrp">
                <app-platform [platform_id]="filter.get('channel_platform_id').value"></app-platform>
                {{ getPlatformById(filter.get('channel_platform_id').value)?.name }}
              </div>
              <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
            </mat-chip>

            <mat-chip (removed)="removeValue('task_operation_operation_id')" *ngIf="filter.get('task_operation_operation_id').value">
              {{ getColumnName(filter.get('task_operation_operation_id').value) }}
              <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
            </mat-chip>

            <mat-chip class="user_chip" (removed)="removeValue('origin_company_id')" *ngIf="filter.get('origin_company_id').value">
              {{ "Partner Client" | translate }}:
              <app-user [class]="'user_div ml-1'" [companyEmployee]="getPartner(filter.get('origin_company_id').value)?.partnerCompany" [imgRoute]="imgRoute" [host]="host" [company]="company"></app-user>
              <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
            </mat-chip>

            <ng-container *ngIf="filter.get('task_parameter_value_id').value.length">
              <span class="chip_out_label">{{ "Tag for task" | translate }}</span>
              <mat-chip *ngFor="let forTaskParamValueId of filter.get('task_parameter_value_id').value" (removed)="removeValueFromMultiple('task_parameter_value_id', forTaskParamValueId)">
                 {{ getValueById(forTaskParamValueId)?.value }}
                <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
              </mat-chip>
            </ng-container>
  
            <ng-container *ngIf="filter.get('task_operation_parameter_value_id').value.length">
              <span class="chip_out_label">{{ "Tag for job" | translate }}</span>
              <mat-chip *ngFor="let forTaskParamValueId of filter.get('task_operation_parameter_value_id').value" (removed)="removeValueFromMultiple('task_operation_parameter_value_id', forTaskParamValueId)">
                 {{ getValueById(forTaskParamValueId)?.value }}
                <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
              </mat-chip>
            </ng-container>
  
            <ng-container *ngIf="filter.get('discussion_parameter_value_id').value.length">
              <span class="chip_out_label">{{ "Tag for chat" | translate }}</span>
              <mat-chip *ngFor="let forTaskParamValueId of filter.get('discussion_parameter_value_id').value" (removed)="removeValueFromMultiple('discussion_parameter_value_id', forTaskParamValueId)">
                 {{ getValueById(forTaskParamValueId)?.value }}
                <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
              </mat-chip>
            </ng-container>
  
            <ng-container *ngIf="filter.get('file_parameter_value_id').value.length">
              <span class="chip_out_label">{{ "Tag for file" | translate }}</span>
              <mat-chip *ngFor="let forTaskParamValueId of filter.get('file_parameter_value_id').value" (removed)="removeValueFromMultiple('file_parameter_value_id', forTaskParamValueId)">
                 {{ getValueById(forTaskParamValueId)?.value }}
                <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
              </mat-chip>
            </ng-container>
  
            <ng-container *ngIf="filter.get('parameter_value_id').value.length">
              <span class="chip_out_label">{{ "Tag for everywhere" | translate }}</span>
              <mat-chip *ngFor="let forTaskParamValueId of filter.get('parameter_value_id').value" (removed)="removeValueFromMultiple('parameter_value_id', forTaskParamValueId)">
                 {{ getValueById(forTaskParamValueId)?.value }}
                <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
              </mat-chip>
            </ng-container>
  


            <ng-container *ngIf="filter.get('channel_id').value.length">
              <span class="chip_out_label">{{ "Card Outlets" | translate }}</span>
              <mat-chip [ngClass]="{'user_chip': id != 0}" *ngFor="let id of filter.get('channel_id').value" (removed)="removeValueFromMultiple('channel_id', id)">
                <ng-container *ngIf="id != 0; else elseTemplateOutletNotSet">
                  <app-outlet-line [channel]="getProfile(id)" [company_id]="company_id"></app-outlet-line>
                </ng-container>
                <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
              </mat-chip>
            </ng-container>
  
            <ng-container *ngIf="filter.get('no_channel_id').value.length">
              <span class="chip_out_label">{{ "Not Presented" | translate }}</span>
              <mat-chip [ngClass]="{'user_chip': id != 0}" *ngFor="let id of filter.get('no_channel_id').value" (removed)="removeValueFromMultiple('no_channel_id', id)">
                <ng-container *ngIf="id != 0; else elseTemplateOutletNotSet">
                  <app-outlet-line [channel]="getProfile(id)" [company_id]="company_id"></app-outlet-line>
                </ng-container>
                <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
              </mat-chip>
            </ng-container>
  
            <ng-template #elseTemplateOutletNotSet>
              {{ "Not Set" | translate}}
            </ng-template>

            <mat-chip (removed)="removeValue('is_content_url')" *ngIf="filter.get('is_content_url').value || filter?.get('is_content_url').value == '0'">
              {{ contentUrl[filter.get('is_content_url').value].name }}
              <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
            </mat-chip>

          <ng-container *ngIf="filter.get('task_created_at_from').value || filter.get('task_created_at_to').value || filter?.get('task_created_at_to').value == '0'">
            <span class="chip_out_label">{{ "Card Added" | translate }}</span>

            <div class="chip_splash"></div>
            
            <ng-container *ngIf="filter.get('task_created_at_from').value">
              <span class="small_chip_out_label">{{ "from" | translate}}</span>
              <mat-chip (removed)="removeValue('task_created_at_from')">
                {{ filter?.get('task_created_at_from').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
                <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
              </mat-chip>
            </ng-container>
    
            <ng-container *ngIf="filter.get('task_created_at_to').value || filter?.get('task_created_at_to').value == '0'">
              <span class="small_chip_out_label">{{ "to" | translate}}</span>
              <mat-chip (removed)="removeValue('task_created_at_to')">
                <ng-container *ngIf="filter.get('task_created_at_to').value == 0; else elseTemplateCompletedFilter">
                  {{ "Without date" | translate }}
                </ng-container>
                <ng-template #elseTemplateCompletedFilter>
                  {{ filter?.get('task_created_at_to').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
                </ng-template>
                <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
              </mat-chip>
            </ng-container>
          </ng-container>

          <ng-container *ngIf="filter.get('task_operation_created_at_from').value || filter.get('task_operation_created_at_to').value || filter?.get('task_operation_created_at_to').value == '0'">
            <span class="chip_out_label">{{ "Job added" | translate }}</span>

            <div class="chip_splash"></div>
            
            <ng-container *ngIf="filter.get('task_operation_created_at_from').value">
              <span class="small_chip_out_label">{{ "from" | translate}}</span>
              <mat-chip (removed)="removeValue('task_operation_created_at_from')">
                {{ filter?.get('task_operation_created_at_from').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
                <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
              </mat-chip>
            </ng-container>
    
            <ng-container *ngIf="filter.get('task_operation_created_at_to').value || filter?.get('task_operation_created_at_to').value == '0'">
              <span class="small_chip_out_label">{{ "to" | translate}}</span>
              <mat-chip (removed)="removeValue('task_operation_created_at_to')">
                <ng-container *ngIf="filter.get('task_operation_created_at_to').value == 0; else elseTemplateCompletedFilter">
                  {{ "Without date" | translate }}
                </ng-container>
                <ng-template #elseTemplateCompletedFilter>
                  {{ filter?.get('task_operation_created_at_to').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
                </ng-template>
                <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
              </mat-chip>
            </ng-container>
          </ng-container>

          <ng-container *ngIf="filter.get('task_operation_completed_at_from').value || filter.get('task_operation_completed_at_to').value || filter?.get('task_operation_completed_at_to').value == '0'">
            <span class="chip_out_label">{{ "Job completed" | translate }}</span>

            <div class="chip_splash"></div>
            
            <ng-container *ngIf="filter.get('task_operation_completed_at_from').value">
              <span class="small_chip_out_label">{{ "from" | translate}}</span>
              <mat-chip (removed)="removeValue('task_operation_completed_at_from')">
                {{ filter?.get('task_operation_completed_at_from').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
                <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
              </mat-chip>
            </ng-container>
    
            <ng-container *ngIf="filter.get('task_operation_completed_at_to').value || filter?.get('task_operation_completed_at_to').value == '0'">
              <span class="small_chip_out_label">{{ "to" | translate}}</span>
              <mat-chip (removed)="removeValue('task_operation_completed_at_to')">
                <ng-container *ngIf="filter.get('task_operation_completed_at_to').value == 0; else elseTemplateCompletedFilter">
                  {{ "Without date" | translate }}
                </ng-container>
                <ng-template #elseTemplateCompletedFilter>
                  {{ filter?.get('task_operation_completed_at_to').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
                </ng-template>
                <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
              </mat-chip>
            </ng-container>
          </ng-container>

          <ng-container *ngIf="filter.get('discussion_created_at_from').value || filter.get('discussion_created_at_to').value || filter?.get('discussion_created_at_to').value == '0'">
            <span class="chip_out_label">{{ "Chat added" | translate }}</span>

            <div class="chip_splash"></div>
            
            <ng-container *ngIf="filter.get('discussion_created_at_from').value">
              <span class="small_chip_out_label">{{ "from" | translate}}</span>
              <mat-chip (removed)="removeValue('discussion_created_at_from')">
                {{ filter?.get('discussion_created_at_from').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
                <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
              </mat-chip>
            </ng-container>
    
            <ng-container *ngIf="filter.get('discussion_created_at_to').value || filter?.get('discussion_created_at_to').value == '0'">
              <span class="small_chip_out_label">{{ "to" | translate}}</span>
              <mat-chip (removed)="removeValue('discussion_created_at_to')">
                <ng-container *ngIf="filter.get('discussion_created_at_to').value == 0; else elseTemplateCompletedFilter">
                  {{ "Without date" | translate }}
                </ng-container>
                <ng-template #elseTemplateCompletedFilter>
                  {{ filter?.get('discussion_created_at_to').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
                </ng-template>
                <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
              </mat-chip>
            </ng-container>
          </ng-container>

          <ng-container *ngIf="filter.get('file_created_at_from').value || filter.get('file_created_at_to').value || filter?.get('file_created_at_to').value == '0'">
            <span class="chip_out_label">{{ "File added" | translate }}</span>

            <div class="chip_splash"></div>
            
            <ng-container *ngIf="filter.get('file_created_at_from').value">
              <span class="small_chip_out_label">{{ "from" | translate}}</span>
              <mat-chip (removed)="removeValue('file_created_at_from')">
                {{ filter?.get('file_created_at_from').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
                <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
              </mat-chip>
            </ng-container>
    
            <ng-container *ngIf="filter.get('file_created_at_to').value || filter?.get('file_created_at_to').value == '0'">
              <span class="small_chip_out_label">{{ "to" | translate}}</span>
              <mat-chip (removed)="removeValue('file_created_at_to')">
                <ng-container *ngIf="filter.get('file_created_at_to').value == 0; else elseTemplateCompletedFilter">
                  {{ "Without date" | translate }}
                </ng-container>
                <ng-template #elseTemplateCompletedFilter>
                  {{ filter?.get('file_created_at_to').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
                </ng-template>
                <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
              </mat-chip>
            </ng-container>
          </ng-container>

          <ng-container *ngIf="filter.get('file_updated_at_from').value || filter.get('file_updated_at_to').value || filter?.get('file_updated_at_to').value == '0'">
            <span class="chip_out_label">{{ "File updated" | translate }}</span>

            <div class="chip_splash"></div>
            
            <ng-container *ngIf="filter.get('file_updated_at_from').value">
              <span class="small_chip_out_label">{{ "from" | translate}}</span>
              <mat-chip (removed)="removeValue('file_updated_at_from')">
                {{ filter?.get('file_updated_at_from').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
                <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
              </mat-chip>
            </ng-container>
    
            <ng-container *ngIf="filter.get('file_updated_at_to').value || filter?.get('file_updated_at_to').value == '0'">
              <span class="small_chip_out_label">{{ "to" | translate}}</span>
              <mat-chip (removed)="removeValue('file_updated_at_to')">
                <ng-container *ngIf="filter.get('file_updated_at_to').value == 0; else elseTemplateCompletedFilter">
                  {{ "Without date" | translate }}
                </ng-container>
                <ng-template #elseTemplateCompletedFilter>
                  {{ filter?.get('file_updated_at_to').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
                </ng-template>
                <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
              </mat-chip>
            </ng-container>
          </ng-container>

          <ng-container *ngIf="filter.get('file_meta_creation_time_from').value || filter.get('file_meta_creation_time_to').value || filter?.get('file_meta_creation_time_to').value == '0'">
            <span class="chip_out_label">{{ "File created" | translate }}</span>

            <div class="chip_splash"></div>
            
            <ng-container *ngIf="filter.get('file_meta_creation_time_from').value">
              <span class="small_chip_out_label">{{ "from" | translate}}</span>
              <mat-chip (removed)="removeValue('file_meta_creation_time_from')">
                {{ filter?.get('file_meta_creation_time_from').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
                <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
              </mat-chip>
            </ng-container>
    
            <ng-container *ngIf="filter.get('file_meta_creation_time_to').value || filter?.get('file_meta_creation_time_to').value == '0'">
              <span class="small_chip_out_label">{{ "to" | translate}}</span>
              <mat-chip (removed)="removeValue('file_meta_creation_time_to')">
                <ng-container *ngIf="filter.get('file_meta_creation_time_to').value == 0; else elseTemplateCompletedFilter">
                  {{ "Without date" | translate }}
                </ng-container>
                <ng-template #elseTemplateCompletedFilter>
                  {{ filter?.get('file_meta_creation_time_to').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
                </ng-template>
                <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
              </mat-chip>
            </ng-container>
          </ng-container>

          <ng-container *ngIf="filter.get('task_channel_published_at_from').value || filter.get('task_channel_published_at_to').value || filter?.get('task_channel_published_at_to').value == '0'">
            <span class="chip_out_label">{{ "Post published" | translate }}</span>

            <div class="chip_splash"></div>
            
            <ng-container *ngIf="filter.get('task_channel_published_at_from').value">
              <span class="small_chip_out_label">{{ "from" | translate}}</span>
              <mat-chip (removed)="removeValue('task_channel_published_at_from')">
                {{ filter?.get('task_channel_published_at_from').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
                <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
              </mat-chip>
            </ng-container>
    
            <ng-container *ngIf="filter.get('task_channel_published_at_to').value || filter?.get('task_channel_published_at_to').value == '0'">
              <span class="small_chip_out_label">{{ "to" | translate}}</span>
              <mat-chip (removed)="removeValue('task_channel_published_at_to')">
                <ng-container *ngIf="filter.get('task_channel_published_at_to').value == 0; else elseTemplateCompletedFilter">
                  {{ "Without date" | translate }}
                </ng-container>
                <ng-template #elseTemplateCompletedFilter>
                  {{ filter?.get('task_channel_published_at_to').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
                </ng-template>
                <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
              </mat-chip>
            </ng-container>
          </ng-container>

            <mat-chip class="user_chip" [ngClass]="{'is_real': !!getEmployee(filter.get('operation_employee_id').value)?.user_id}" (removed)="removeValue('operation_employee_id')" *ngIf="filter.get('operation_employee_id').value && filter?.get('operation_employee_id').value.length > 0">
                <ng-container *ngIf="filter.get('operation_employee_id').value == 0; else elseTemplateWithoutExec">
                {{ "Without executor" | translate }} 
                </ng-container>
                <ng-template #elseTemplateWithoutExec>
                <app-user [class]="'user_div'" [employee]="getEmployee(filter.get('operation_employee_id').value)"></app-user>
                </ng-template>
                
                <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
            </mat-chip>

            <mat-chip class="user_chip" (removed)="removeValue('operation_partner_company_id')" *ngIf="filter.get('operation_partner_company_id').value && filter?.get('operation_partner_company_id').value.length > 0">
                {{ "Partner" | translate }}:
                <app-user [class]="'user_div ml-1'" [companyEmployee]="getPartner(filter.get('operation_partner_company_id').value)?.partnerCompany" [imgRoute]="imgRoute" [host]="host" [company]="company"></app-user>
                <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
            </mat-chip>

            <mat-chip class="user_chip" [ngClass]="{'is_real': !!getEmployee(filter.get('client_employee_id').value)?.user_id}" (removed)="removeValue('client_employee_id')" *ngIf="filter.get('client_employee_id').value">
                {{ "Client" | translate }}:
                <app-user [class]="'user_div ml-1'" [employee]="getEmployee(filter.get('client_employee_id').value)"></app-user>
                <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
            </mat-chip>

            <mat-icon *ngIf="activatedRoute.snapshot.queryParamMap.get('q') || filter.get('content_type').value || filter.get('task_custom_id').value || filter?.get('file_id')?.value || filter.get('consist_of_count').value || filter.get('part_of_count').value || filter.get('related_count').value || filter.get('origin_company_id').value || filter.get('operation_reminder_id').value || (filter.get('is_ready_if_approved').value == '0' || filter.get('is_ready_if_approved').value) || filter.get('meta_device').value || filter.get('priority').value || filter.get('task_created_at_from').value || filter.get('task_created_at_to').value || filter?.get('task_created_at_to').value == '0' || filter.get('task_operation_created_at_from').value || filter.get('task_operation_created_at_to').value || filter?.get('task_operation_created_at_to').value == '0' || filter.get('task_operation_completed_at_from').value || filter.get('task_operation_completed_at_to').value || filter?.get('task_operation_completed_at_to').value == '0' || filter.get('discussion_created_at_from').value || filter.get('discussion_created_at_to').value || filter?.get('discussion_created_at_to').value == '0' || filter.get('file_created_at_from').value || filter.get('file_created_at_to').value || filter?.get('file_created_at_to').value == '0' || filter.get('file_updated_at_from').value || filter.get('file_updated_at_to').value || filter?.get('file_updated_at_to').value == '0' || filter.get('file_meta_creation_time_from').value || filter.get('file_meta_creation_time_to').value || filter?.get('file_meta_creation_time_to').value == '0' || filter.get('task_channel_published_at_from').value || filter.get('task_channel_published_at_to').value || filter?.get('task_channel_published_at_to').value == '0' || (filter.get('is_content_url').value || filter?.get('is_content_url').value == '0') || activatedRoute.snapshot.queryParamMap.get('task_status_id') || filter.get('task_parameter_value_id').value.length || filter.get('discussion_parameter_value_id').value.length || filter.get('task_operation_parameter_value_id').value.length || filter.get('parameter_value_id').value.length || filter.get('file_parameter_value_id').value.length || filter.get('content_type_id').value.toString() == '0' || filter.get('no_channel_id').value.length || filter.get('group_id').value.length || filter.get('channel_platform_id').value.toString() == '0' || filter.get('content_type_id').value || filter.get('channel_platform_id').value || filter.get('channel_id').value.length || filter?.get('content_status_id').value || filter?.get('task_channel_file_content_status_id').value" class="remove_all_chips_btn" (click)="removeValue('all')">cancel</mat-icon>
          </mat-chip-list> -->
  
          <div class="stats_wrp ml-1">
            <div class="tasks_counters">
              <div class="grouped_check mr-1">
                <mat-checkbox color="primary" (change)="changeGroup($event)" *ngIf="!!filter.get('group_by')" [checked]="filter.get('group_by').value == 'original_file_id'">{{ "Group copies" | translate }}</mat-checkbox>
              </div>
              <!-- {{indicator()}} ---
              {{filter?.get('location_all')?.value}} -->
              <ng-container *ngIf="indicator()">
                <div class="server_btn mr-1" (click)="clearFolder()">
                  <mat-icon>delete_outline</mat-icon>
                  <span>
                    {{ (isTrash(filter.get('location_all').value) ? "Delete forever" : "Move to trash") | translate}}
                  </span>
                </div>
              </ng-container>

              <form [formGroup]="filter" class="preset_form" *ngIf="bookmarks && bookmarks.length > 0">
                <div class="simple_filter_snippet" (click)="presetFilter.open()">
                  <ng-container *ngIf="filter.get('preset_id').value; else elseTemplatePreset">
                    <span class="name">
                      {{ getBookmarkById(filter.get('preset_id').value)?.name }}
                    </span>
                  </ng-container>
                  <ng-template #elseTemplatePreset>
                    <span class="name">
                      {{ "Preset" | translate }}
                    </span>
                  </ng-template>
                  

                  <svg style="width: 18px; height: 18px;" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_2474_38987)">
                    <path d="M7.91699 3.33325L2.08366 3.33325L5.00033 7.91658L7.91699 3.33325Z" fill="black"/>
                    </g>
                    <defs>
                    <clipPath id="clip0_2474_38987">
                    <rect width="10" height="10" fill="white" transform="translate(10) rotate(90)"/>
                    </clipPath>
                    </defs>
                  </svg>
                </div>

                <mat-form-field appearance="legacy" class="filter_form preset_filter">
                  <mat-label>{{ "Preset" | translate }}</mat-label>
                  <mat-select #presetFilter [disableOptionCentering]="true" selectDir formControlName="preset_id" (selectionChange)="bookmarksChange($event)">
                      <mat-option *ngIf="bookmarks.length > 7">
                        <ngx-mat-select-search 
                            placeholderLabel="{{ 'Search' | translate }}" 
                            noEntriesFoundLabel="{{ 'no matching presets found' | translate }}"
                            [formControl]="bookmarksControl"></ngx-mat-select-search>
                      </mat-option>
                      <mat-option *ngFor="let bookmark of bookmarks$ | async" [value]="bookmark.id">
                        {{ bookmark.name | translate }}
                      </mat-option>
                  </mat-select>
                </mat-form-field>
              </form>

              <button type="button" mat-icon-button (click)="refreshPage()" #tooltip="matTooltip"
              matTooltip="{{ 'Refresh results on the page' | translate }}"
              [matTooltipPosition]="'above'">
                <mat-icon>refresh</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
</div>
<ng-container *ngIf="!is_mobile; else elseTemplateMobGlobFM">
  <app-file-manager
  [company]="company"
  [id]="filesID"
  [globalFilterFmFilesForm]="filter"
  [globalFilterFmFiles]="filter.value"
  [isGlobal]="true"
  [sortValue]="sortValue"
  [is_global]="true">
  </app-file-manager>
</ng-container>
<ng-template #elseTemplateMobGlobFM>
  <app-mob-file-manager
  [company]="company"
  [globalFilterFmFilesForm]="filter"
  [globalFilterFmFiles]="filter.value"
  [isGlobal]="true"
  [sortValue]="sortValue"
  [is_global]="true">
  </app-mob-file-manager>
</ng-template>





<!-- <app-file-manager
[initLocation]="data.loc"
[task]="data.task"
[work]="data.work"
[company]="data.company"
[tasks]="data.tasks"
[is_global]="data.is_global"
(HideMenu)="close()"
[initData]="{
    'task': data?.task,
    'work': data?.work,
    'company': data?.company
}"></app-file-manager> -->